import React, { Component } from "react";
import Progress from "../Progress/Progress";
import Payment from "../Payment/Payment";
import BackNext from "../BackNext/BackNext";
import Form2 from "../Form2/Form2";
import Form3 from "../Form3/Form3";
import "./Onboarding.css";

class Onboarding extends Component {
	// Onboarding screen after signup form
	render() {
		return (
			<div className="onboarding container">
				<Progress
					onboardingStepBuyer={this.props.onboardingStepBuyer}
					onboardingFlowBuyer={this.props.onboardingFlowBuyer}
				/>
				<div className="onboarding-flow-ui">
					{this.props.onboardingStepBuyer === 1 && (
						<Form2
							trianglify={this.props.trianglify}
							onboardingStepBuyer={this.props.onboardingStepBuyer}
							onboardingFlowBuyer={this.props.onboardingFlowBuyer}
							nextOnboardingBuyer={this.props.nextOnboardingBuyer}
							backOnboardingBuyer={this.props.backOnboardingBuyer}
							signUpParamsBuyer={this.props.signUpParamsBuyer}
							onChangeInput={this.props.onChangeInput}
						/>
					)}
					
					
					{this.props.onboardingStepBuyer === 2 && (
						<Form3
							trianglify={this.props.trianglify}
							onboardingStepBuyer={this.props.onboardingStepBuyer}
							onboardingFlowBuyer={this.props.onboardingFlowBuyer}
							nextOnboardingBuyer={this.props.nextOnboardingBuyer}
							backOnboardingBuyer={this.props.backOnboardingBuyer}
							signUpParamsBuyer={this.props.signUpParamsBuyer}
							onChangeInput={this.props.onChangeInput}
						/>
					)}
					
					
					{this.props.onboardingStepBuyer === 3 && (
						<Payment
							getSignUpProductTotalBuyer={this.props.getSignUpProductTotalBuyer}
							signUpParamsBuyer={this.props.signUpParamsBuyer}
							onTokenBuyer={this.props.onTokenBuyer}
						/>
					)}
				</div>
				{this.props.onboardingStepBuyer === 3 && (
				<BackNext
					nextOnboardingBuyer={this.props.nextOnboardingBuyer}
					backOnboardingBuyer={this.props.backOnboardingBuyer}
					back={true}
					next={this.props.onboardingStepBuyer === 3 ? false : true}
				/>)}
			</div>
		);
	}
}

export default Onboarding;


// WEBPACK FOOTER //
// ./src/components/BuyerList/Onboarding/Onboarding.js